const routes = [
  {
    path: "/auth",
    component: () => import("@/layouts/auth"),
    name: "auth-layout",
    children: [
      {
        path: "sign-in",
        component: () => import("@/pages/auth/sign-in"),
      },
    ],
  },
  {
    path: "/cabinet",
    component: () => import("@/layouts/default"),
    name: "default-layout",
    meta: { breadcrumb: "Kadrlar" },
    children: [
      {
        path: "admin",
        name: "cabinet-admin",
        meta: { breadcrumb: "Admin" },
        children: [
          {
            path: "staff-statistics",
            component: () => import("@/pages/cabinet/admin"),
            name: "cabinet-admin-staff-statistics",
          },
          {
            path: "users",
            component: () => import("@/pages/cabinet/admin/users"),
            name: "cabinet-admin-users",
            meta: { breadcrumb: "Foydalanuvchilar" },
          },
          {
            path: "users/create",
            component: () => import("@/pages/cabinet/admin/users/create"),
            name: "cabinet-admin-users-create",
            meta: { breadcrumb: "Yangi foydalanuvchi yaratish" },
          },
          {
            path: "users/update/:id",
            component: () =>
              import("@/pages/cabinet/admin/users/update/[id].vue"),
            name: "cabinet-admin-users-update",
          },
          {
            path: "users/staff-statistics/:id",
            component: () =>
              import("@/pages/cabinet/admin/users/staff-statistics"),
            name: "cabinet-admin-users-staff-statistics",
          },
          {
            path: "domains",
            component: () => import("@/pages/cabinet/admin/domains"),
            name: "cabinet-admin-domains",
            meta: { breadcrumb: "Domenlar" },
          },
          {
            path: "domains/calendar",
            component: () => import("@/pages/cabinet/admin/domains/calendar"),
            name: "cabinet-admin-domains-calendar",
            meta: { breadcrumb: "Domenlar Taqvimi" },
          },
        ],
      },
    ],
  },
];

export default routes;
